{
  "alert": "Teade",
  "dismiss": "Lõpeta"
}